module.exports = __webpack_public_path__ + "static/media/02_quote_mobile.824bae14.jpg";